import template from './app.jade';
import './styles/app.scss';

export class AppController {
  /* @ngInject */
  constructor($auth, $http, api, MeResource, currentUser, header) {
    this.$http = $http;
    this.$auth = $auth;
    this.header = header;
    this.api = api;

    if (this.$auth.isAuthenticated()) {
      MeResource.one().get().then((user) => {
        this.$http.get(`${this.api.baseURL}/oauth/token/mfa/isToggled`).then((response) => {
          user.isMfaToggled = response.data.result;
          currentUser.onNext(user);
        })
      });
    }
  }
}

export default function AppComponent() {
  return {
    template,
    controller: AppController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
}



/** WEBPACK FOOTER **
 ** ./src/app.component.js
 **/